import { Component, Input, OnInit } from '@angular/core';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-blue-pill',
  templateUrl: './lex-blue-pill.component.html',
  styleUrls: ['./lex-blue-pill.component.scss'],
  standalone: false,
})
export class LexBluePillComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() text: string;
  @Input() size: 'small' | 'normal' | 'large' = 'normal';
  @Input() textAlign: 'left' | 'center' | 'right' = 'left';

  height: number;
  fontSize: number;

  ngOnInit(): void {
    this.setSizes();
  }

  private setSizes(): void {
    switch (this.size) {
      default:
      case 'small':
        {
          this.height = 30;
          this.fontSize = 14;
        }
        break;
      case 'normal':
        {
          this.height = 36;
          this.fontSize = 16;
        }
        break;
      case 'large':
        {
          this.height = 42;
          this.fontSize = 18;
        }
        break;
    }
  }

  isOverflow(el: HTMLElement): boolean {
    return el.clientWidth < el.scrollWidth;
  }
}
